import useRates from './use-rates.js';

const usePrice = (assetTicker: string) => {
  const { loading, value: rates } = useRates();
  return { loading, value: rates[assetTicker]?.price };
};

export default usePrice;
